import React from 'react';
import { formatLaunchTime } from '../../../_shared/helpers/formatting';
import ListSaleEventHeader from './ListSaleEventHeader';
import { ListVariant } from '../../../_shared/types/trade';
import GridSaleEventHeader from './GridSaleEventHeader';

const SaleEventHeader = props => {
  const { listVariant, tradeSummary, tradeState } = props;

  const { statusDates, saleEventSummary } = tradeSummary;
  const { id: launchId, values: launchValues } = formatLaunchTime(
    tradeState,
    statusDates,
    null
  );

  const launchIdSale = launchId ? launchId.concat('.sale') : null;

  const isChangeHostedBy = !!(
    (saleEventSummary?.isMultiRooftopEvent &&
      saleEventSummary?.isDealerGroupNetwork) ||
    saleEventSummary?.dgnNetwork
  );

  const shouldHideHostedBy =
    saleEventSummary?.isMultiRooftopEvent && !saleEventSummary?.dgnNetwork;

  return listVariant !== ListVariant.GRID ? (
    <ListSaleEventHeader
      {...props}
      shouldHideHostedBy={shouldHideHostedBy}
      isChangeHostedBy={isChangeHostedBy}
      launchIdSale={launchIdSale}
      launchValues={launchValues}
    />
  ) : (
    <GridSaleEventHeader
      {...props}
      shouldHideHostedBy={shouldHideHostedBy}
      isChangeHostedBy={isChangeHostedBy}
      launchIdSale={launchIdSale}
      launchValues={launchValues}
    />
  );
};

export default SaleEventHeader;
